<div class="" [class.card]="card">
    <div class="" [class.card-body]="card">
        <div class="stepper stepper-pills stepper-column d-flex flex-column flex-lg-row scrollable-hidden-scrollbar" *ngIf="formLayout$ | async as formLayout">
            <div class="content" appOverflow (overflow)="onOverflow($event)" (atEnd)="onScrollEnd($event)" (atStart)="onScrollStart($event)" #contentStepper>
                <div class="d-flex flex-row-auto">
                    <!--VERTICAL LAYOUT-->
                    <div class="stepper-nav flex-center" *ngIf="!formLayout.horizontalLayout">
                        <div class="text-center w-100" *ngIf="currentIndex != 1 && formLayout.navigationButtons"
                            (click)="previousTab()">
                            <button class="btn btn-icon btn-sm">
                                <i class="fas fa-chevron-up mt-2 chevron-icon"></i>
                            </button>
                        </div>
                        <div class="stepper-item  me-5" (click)="setSelectedTab(i + 1)"
                            *ngFor="let item of formLayout.menuItems; let i = index; let l = last;"
                            [class.mark-completed]="item.completed" [class.pending]="item.id > formLayout.selectedMenu"
                            [class.current]="item.id === formLayout.selectedMenu">
                            <!--begin::Wrapper-->
                            <div class="stepper-wrapper" [ngClass]="{ 'menu-number-container': !formLayout.menuClickDisable }">
                                <div class="stepper-icon m-0 rounded-3 me-5" style="border-color: #50CD89;">
                                    <i class="fs-3 fa-fh fas" [ngClass]="'fa-fw fa-' + item.icon"
                                        *ngIf="item.icon != '' && item.icon"
                                        [class.text-success]="item.id !== formLayout.selectedMenu"
                                        [class.text-white]="item.id === formLayout.selectedMenu"></i>
                                    <span class="stepper-number"
                                        *ngIf="item.icon == '' || !item.icon">{{item.id}}</span>
                                </div>
                                <div class="stepper-label me-5">
                                    <h3 class="stepper-title mb-0"
                                        [class.text-muted]="item.id !== formLayout.selectedMenu"
                                        [class.text-dark]="item.id === formLayout.selectedMenu">
                                        {{item.label}}
                                    </h3>

                                    <div class="stepper-desc" [class.text-danger]="item.valid === false">
                                        {{item.description}}
                                    </div>
                                </div>
                                <div class="me-5" *ngIf="item.valid === false">
                                    <i class="fa-duotone fa-circle-dot fa-beat-fade"
                                        style="--fa-primary-color: #da190b; --fa-secondary-color: #da190b;"></i>
                                </div>
                            </div>
                            <!--end::Wrapper-->

                            <!--begin::Line-->
                            <div class="stepper-line h-40px" *ngIf="!l"></div>
                            <!--end::Line-->
                        </div>
                        <div class="text-center w-100"
                            *ngIf="currentIndex != formLayout.menuItems.length && formLayout.navigationButtons"
                            (click)="nextTab()">
                            <button class="btn btn-icon btn-sm">
                                <i class="fas fa-chevron-down mt-2 chevron-icon"></i>
                            </button>
                        </div>

                    </div>
                    <!-- HORIZONTAL LAYOUT -->
                    <div class="stepper-nav" style="flex-direction: row;" *ngIf="formLayout.horizontalLayout && !hasChecks">
                        <div class="navigation-left-navigation-container h-100" *ngIf="hasOverflow && !atStart">
                            <div class="d-flex flex-row align-items-middle me-2">
                                <button class="btn btn-icon btn-sm" (click)="scrollToLeft(300)">
                                    <i class="fas fa-chevron-left mt-2 chevron-icon"></i>
                                </button>
                            </div>
                        </div>

                        <ng-container *ngFor="let item of formLayout.menuItems; let i = index; let l = last;">
                            <div [id]="item.label + item.id" class="stepper-item w-100" [class.current]="item.id === formLayout.selectedMenu" (click)="setSelectedTab(item.id)">
                                <div class="stepper-wrapper me-5" [ngClass]="{ 'menu-number-container': !formLayout.menuClickDisable }">
                                    <div class="stepper-icon m-0 rounded-3 me-5" style="border-color: #50CD89;">
                                        <i class="fs-3 fa-fh fas" [ngClass]="'fa-fw fa-' + item.icon" *ngIf="item.icon != '' && item.icon" [class.text-white]="item.id === formLayout.selectedMenu"></i>
                                        <span class="stepper-number" *ngIf="item.icon == '' || !item.icon">{{item.id}}</span>
                                    </div>
                                    <div class="stepper-label me-2" style="text-wrap: nowrap;">
                                        <h3 class="stepper-title mb-0"
                                            [ngClass]="
                                                {
                                                    'fw-semibold text-gray-600': item.id !== formLayout.selectedMenu,
                                                    'fw-bold text-success': item.id === formLayout.selectedMenu
                                                }">
                                            {{item.label}}
                                        </h3>

                                        <div class="stepper-desc w-100" [class.text-danger]="item.valid === false" style="white-space: nowrap !important;">
                                            {{item.description}}
                                        </div>
                                    </div>
                                    <!-- <i class="fs-3"
                                        [ngClass]="
                                            {
                                                'fas fa-circle-check': item.id < formLayout.selectedMenu,
                                                'far fa-circle': item.id >= formLayout.selectedMenu,

                                                'text-success': item.id === formLayout.selectedMenu,
                                                'text-gray-600': item.id !== formLayout.selectedMenu
                                            }"
                                    ></i> -->
                                    <div class="me-5" *ngIf="item.valid === false">
                                        <i class="fa-duotone fa-circle-dot fa-beat-fade" style="--fa-primary-color: #da190b; --fa-secondary-color: #da190b;"></i>
                                    </div>
                                    <div class="horizontal-stepper-line w-50px ms-5" *ngIf="!l"></div>
                                </div>
                            </div>
                        </ng-container>

                        <div class="navigation-right-navigation-container h-100" *ngIf="hasOverflow && !atEnd">
                            <div class="d-flex flex-row align-items-middle ms-2 pe-2">
                                <!--<div class="vertical-separator"></div>-->
                                <button class="btn btn-icon btn-sm" (click)="scrollToRight(300)">
                                    <i class="fas fa-chevron-right mt-2 chevron-icon"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- HORIZONTAL LAYOUT - CHECKS -->
                    <div class="stepper-nav" style="flex-direction: row;" *ngIf="formLayout.horizontalLayout && hasChecks">
                        <div class="navigation-left-navigation-container h-100" *ngIf="hasOverflow && !atStart">
                            <div class="d-flex flex-row align-items-middle me-2">
                                <button class="btn btn-icon btn-sm" (click)="scrollToLeft(300)">
                                    <i class="fas fa-chevron-left mt-2 chevron-icon"></i>
                                </button>
                            </div>
                        </div>

                        <ng-container class="me-5" *ngFor="let item of formLayout.menuItems; let i = index; let l = last;">
                            <div [id]="item.label + item.id" class="stepper-item w-100" [class.current]="item.id === formLayout.selectedMenu" (click)="setSelectedTab(item.id)">
                                <div class="stepper-wrapper me-5" [ngClass]="{ 'menu-number-container': !formLayout.menuClickDisable }">
                                    <!-- <div class="stepper-icon m-0 rounded-3 me-5" style="border-color: #50CD89;">
                                        <i class="fs-3 fa-fh fas" [ngClass]="'fa-fw fa-' + item.icon" *ngIf="item.icon != '' && item.icon" [class.text-white]="item.id === formLayout.selectedMenu"></i>
                                        <span class="stepper-number" *ngIf="item.icon == '' || !item.icon">{{item.id}}</span>
                                    </div> -->
                                    <div class="stepper-label me-2" style="text-wrap: nowrap;">
                                        <h3 class="stepper-title mb-0"
                                            [ngClass]="
                                                {
                                                    'fw-semibold text-gray-600': item.id !== formLayout.selectedMenu,
                                                    'fw-bold text-success': item.id === formLayout.selectedMenu
                                                }">
                                            {{item.label}}
                                        </h3>

                                        <div class="stepper-desc w-100" [class.text-danger]="item.valid === false" style="white-space: nowrap !important;">
                                            {{item.description}}
                                        </div>
                                    </div>
                                    <i class="fs-3"
                                        [ngClass]="
                                            {
                                                'fas fa-circle-check': item.id < formLayout.selectedMenu,
                                                'far fa-circle': item.id >= formLayout.selectedMenu,

                                                'text-success': item.id === formLayout.selectedMenu,
                                                'text-gray-600': item.id !== formLayout.selectedMenu
                                            }"
                                    ></i>
                                    <div class="horizontal-stepper-line w-50px ms-5" *ngIf="!l"></div>
                                </div>
                            </div>
                        </ng-container>

                        <div class="navigation-right-navigation-container h-100" *ngIf="hasOverflow && !atEnd">
                            <div class="d-flex flex-row align-items-middle ms-2 pe-2">
                                <!--<div class="vertical-separator"></div>-->
                                <button class="btn btn-icon btn-sm" (click)="scrollToRight(300)">
                                    <i class="fas fa-chevron-right mt-2 chevron-icon"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>